module.exports = __webpack_public_path__ + "img/voice-lab-sm.5eeb5202.png";